import React from 'react'
import RoomsFilter from './RoomsFilter'
import RoomsList from "./RoomsList";
import {withRoomConsumer} from '../context'
import Loading from './Loading';

function RoomConsumer({context}) {
    const {loading, sortedRooms, rooms} = context;
    if (loading) {
      return <Loading />;
    }
    return (
      <div>
        <RoomsFilter rooms={rooms} />
        <RoomsList rooms={sortedRooms} />
      </div>
    );

}


export default withRoomConsumer(RoomConsumer)

// import React from 'react'
// import RoomsFilter from './RoomsFilter'
// import RoomsList from "./RoomsList";
// import {RoomContainer, RoomConsumer} from '../context'
// import Loading from './Loading';

// export default function RoomsContainer() {
//     return (
//         <RoomConsumer>
//             {
//                 (value) => {

//                     const {loading,sortedRooms,rooms} = value

//                     if(loading){
//                         return <Loading/>;
//                     }
//                     return (
//                     <div>
//                       Hello From Rooms Container
//                       <RoomsFilter rooms={rooms}/>
//                       <RoomsList rooms={sortedRooms}/>
//                     </div>
//                     );
                    
//                 }
//             }
//         </RoomConsumer>
        
//     )
// }
